import { registerTranslationRefresh, t as lnT } from '../i18n';
import { FaRegStickyNote } from 'react-icons/fa';
import { FiMessageSquare } from 'react-icons/fi';
import { CONTENT_PRESET_COLORS } from './contentPresetColors';
import { IoIosCheckmarkCircleOutline } from 'react-icons/io';
import {
    IoBookmarkOutline,
    IoChatbubbleOutline,
    IoDocumentOutline,
    IoImageOutline,
    IoMailOutline,
    IoMusicalNoteOutline,
    IoStarOutline,
    IoVideocamOutline
} from 'react-icons/io5';

export const TYPE_FOLDER_ID_PREFIX = 'type-';
export const DEFAULT_SIDEBAR_TYPE_IDS = ['chat', 'files', 'images', 'videos', 'threads'];

const makeTranslatedMESSAGE_TYPE_PRESETS = () => ([
    { id: 'audio', label: lnT('folders:audio'), Icon: IoMusicalNoteOutline, iconColor: CONTENT_PRESET_COLORS.type.audio, filters: { type: ['AUDIO'] } },
    { id: 'chat', label: lnT('common:chats'), Icon: IoChatbubbleOutline, iconColor: CONTENT_PRESET_COLORS.type.chat, filters: { hasChat: true } },
    { id: 'emails', label: lnT('folders:emails'), Icon: IoMailOutline, iconColor: CONTENT_PRESET_COLORS.type.emails, filters: { type: ['EMAIL'] } },
    { id: 'files', label: lnT('folders:files'), Icon: IoDocumentOutline, iconColor: CONTENT_PRESET_COLORS.type.files, filters: { type: ['FILE'] } },
    { id: 'images', label: lnT('folders:images'), Icon: IoImageOutline, iconColor: CONTENT_PRESET_COLORS.type.images, filters: { type: ['IMAGE'] } },
    { id: 'videos', label: lnT('common:videos'), Icon: IoVideocamOutline, iconColor: CONTENT_PRESET_COLORS.type.videos, filters: { type: ['VIDEO'] } },
    { id: 'links', label: lnT('folders:links'), Icon: IoBookmarkOutline, iconColor: CONTENT_PRESET_COLORS.type.links, filters: { type: ['META_URL'] } },
    { id: 'notes', label: lnT('folders:notes'), Icon: FaRegStickyNote, iconColor: CONTENT_PRESET_COLORS.type.notes, filters: { type: ['NOTE'] } },
    { id: 'stars', label: lnT('folders:stars'), Icon: IoStarOutline, iconColor: CONTENT_PRESET_COLORS.type.stars, filters: { type: ['STAR'] } },
    { id: 'tasks', label: lnT('common:tasks'), Icon: IoIosCheckmarkCircleOutline, iconColor: CONTENT_PRESET_COLORS.type.tasks, filters: { type: ['CHECK'] } },
    { id: 'text', label: lnT('folders:text'), Icon: FiMessageSquare, iconColor: CONTENT_PRESET_COLORS.type.text, filters: { type: ['TEXT'] } },
    { id: 'threads', label: lnT('common:threads'), Icon: FiMessageSquare, iconColor: CONTENT_PRESET_COLORS.type.threads, filters: { hasThreadMessages: true } }
]);
export let MESSAGE_TYPE_PRESETS = makeTranslatedMESSAGE_TYPE_PRESETS();
registerTranslationRefresh(() => { MESSAGE_TYPE_PRESETS = makeTranslatedMESSAGE_TYPE_PRESETS(); });

export const getTypePreset = typeId =>
    MESSAGE_TYPE_PRESETS.find(preset => preset.id === typeId);

export const createTypeFolder = preset => ({
    id: `${TYPE_FOLDER_ID_PREFIX}${preset.id}`,
    title: preset.label,
    typePresetId: preset.id,
    isType: true
});

export const getTypeFolderFromSlug = slug => {
    if (!String(slug || '').startsWith(TYPE_FOLDER_ID_PREFIX)) return null;
    const preset = getTypePreset(String(slug).slice(TYPE_FOLDER_ID_PREFIX.length));
    return preset ? createTypeFolder(preset) : null;
};
